<template>
  <div>
    <NavBar />
    <div class="container">
      <SideBar />     
      <div class="content">
        <div class="content-wrapper">
          <Loading :isActive="loading"></Loading>
          <h1 class="title">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 512.014 512.014" style="enable-background:new 0 0 512.014 512.014;" xml:space="preserve"> <g> <g> <path d="M510.795,57.902c-2.464-5.984-8.32-9.888-14.784-9.888h-32v-32c0-6.464-3.904-12.32-9.888-14.784 c-5.952-2.496-12.832-1.12-17.44,3.456l-48,48c-2.976,3.008-4.672,7.072-4.672,11.328v41.376L212.683,276.686 c-6.24,6.24-6.24,16.384,0,22.624c3.136,3.136,7.232,4.704,11.328,4.704s8.192-1.568,11.328-4.672l171.296-171.328h41.376 c4.256,0,8.32-1.696,11.328-4.672l48-48C511.883,70.734,513.259,63.886,510.795,57.902z"/> </g> </g> <g> <g> <path d="M342.027,238.574l-54.56,54.752c-2.72,32.832-29.92,58.688-63.456,58.688c-35.36,0-64-28.64-64-64 c0-34.208,26.912-61.92,60.672-63.68l53.728-53.92c-15.488-6.656-32.48-10.4-50.4-10.4c-70.592,0-128,57.408-128,128 s57.408,128,128,128s128-57.408,128-128C352.011,270.478,348.427,253.806,342.027,238.574z"/> </g> </g> <g> <g> <path d="M412.715,167.662l-47.168,47.328c11.392,21.984,18.464,46.592,18.464,73.024c0,88.224-71.776,160-160,160 s-160-71.776-160-160s71.776-160,160-160c26.784,0,51.648,7.232,73.856,18.912l47.104-47.264 c-34.912-22.464-76.384-35.648-120.96-35.648c-123.712,0-224,100.288-224,224s100.288,224,224,224s224-100.288,224-224 C448.011,243.662,434.955,202.446,412.715,167.662z"/> </g> </g> </svg>
            Slogan
          </h1>
          <ul class="tabs">
            <li class="tab-active">
              <router-link to="/slogan">Dados</router-link>
            </li>
            <li>
              <router-link to="/slogan/banners">Banners</router-link>
            </li>
          </ul>
          <div class="card">
            <div class="card-body">
              <form class="form" v-on:submit.prevent="onSubmit">
                <div class="row">
                  <div class="col-1">
                    <div class="form-group">
                      <label for="">Slogan</label>
                      <vue-editor id="editor1" v-model="item.slogan" :editorToolbar="customToolbar"></vue-editor>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-1">
                    <div class="form-group">
                      <label for="">Descrição do Slogan</label>
                      <vue-editor id="editor2" v-model="item.texto" :editorToolbar="customToolbar"></vue-editor>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-actions">
                    <button class="button button-lg button-primary">
                      Salvar
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      </SideBar>
    </div>
  </div>
</template>

<script>

import { get, put } from '@/helpers/apiRequest'
import { customToolbar } from '@/helpers/utils'
const url = '/slogan'

export default {
  name: 'slogan',
  data () {
    return {
      loading: false,
      customToolbar: customToolbar(),
      item: {
        
      }
    }
  },
  methods: {
    onSubmit () {
      this.save()
    },
    save () {
      this.loading = true
      put(`${url}/${this.item._id}`, this.item)
        .then(json => {
          this.loading = false
          this.$swal({ title: 'Dados Alterados com Sucesso!', type: 'success'})
        })
        .catch(err => console.log('err', err))
    }
  },
  beforeMount () {
    this.loading = true
    get(url)
      .then(json => {
        this.loading = false
        this.item = json
      })
      .catch(err => console.log('err', err))
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Slogan/Slogan.vue